import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/** Redirect landing page for creator referral links: /join/{slug} → /register?ref={slug} */
export default function JoinCreator() {
  const { slug } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    if (!slug) { nav("/register"); return; }
    // Save it so registration form can pick it up
    try { localStorage.setItem("cp_ref_slug", slug); } catch {}
    nav(`/register?ref=${encodeURIComponent(slug)}`, { replace: true });
  }, [slug, nav]);
  return null;
}
